var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['frame-modal', { 'active': _vm.isActive }]},[_c('div',{staticClass:"modal-bar"},[_c('div',{staticClass:"modal-bar-content"},[_vm._t("modal-title")],2)]),_vm._t("modal-content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }